import axios from "axios";
import { getToken } from "../Utils/UpdateUsersState";

const getDecisionEngine = async (to, from) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}decision-engine`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: { to, from },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const getRecommendedFuelPumps = async (to, from , origin , destination, tracker) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}route-predictor`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: { to, from, origin, destination, tracker },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const getRecommendation = async (to, from) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}recommendation`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: { to, from},
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export { getDecisionEngine, getRecommendedFuelPumps, getRecommendation };
